import request from '@/utils/request'

export function authorize(params) {
  return request({
    url: '/wechat/login',
    method: 'post',
    params
  })
}

export function getProductList(params) {
  return request({
    url: '/product/getList',
    method: 'get',
    params: params
  })
}

export function findProductById(params) {
  return request({
    url: '/product/findProductById',
    method: 'post',
    params
  })
}

export function getJsapiTicket(params) {
  return request({
    url: '/wechat/getJsapiTicket',
    method: 'post',
    params
  })
}

export function findCategoryById(params) {
  return request({
    url: '/category/findCategoryById',
    method: 'post',
    params
  })
}


export function findCategoryList(params) {
  return request({
    url: '/category/findCategoryList',
    method: 'post',
    params
  })
}


export function createTrafficInsure(params) {
  return request({
    url: '/trafficInsure/createInsureTraffic',
    method: 'post',
    params
  })
}

export function createInsure(params) {
  return request({
    url: '/driver/createInsureDriver',
    method: 'post',
    params
  })
}

export function insureCreateInsure(params) {
  return request({
    url: '/student/createInsureStudent',
    method: 'post',
    params
  })
}

export function findUser(params) {
  return request({
    url: '/wechat/findUser',
    method: 'post'
  })
}

export function createElectroInsure(params) {
  return request({
    url: '/electro/createElectroInsure',
    method: 'post',
    params
  })
}

export function findInsureList(params) {
  return request({
    url: '/insure/findInsureList',
    method: 'post',
    params
  })
}

export function uploadBankCard(params) {
  return request({
    url: '/bankCard/uploadBankCard',
    method: 'post',
    params
  })
}

export function payInsure(params) {
  return request({
    url: '/student/payInsure',
    method: 'post',
    params
  })
}

export function createMotorInsure(params) {
  return request({
    url: '/motor/createMotorInsure',
    method: 'post',
    params
  })
}

export function createDriverInsure(params) {
  return request({
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    url: '/weixinInsure/createInsure',
    method: 'post',
    data: params
  })
}

export function getVerification(params) {
  return request({
    url: '/verification/getVerification',
    method: 'get',
    params: params
  })
}

//单文件上传
export function uploadIdCard(params) {
  return request({
    url: '/image/getSfzm?idCardSide=front',
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    data: params
  })
}

export function uploadCarCard(params) {
  return request({
    url: '/image/getVehicleLicense?path=vehicleLicense',
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    data: params
  })
}

export function commonUploadFile(params) {
  return request({
    url: '/image/uploadFile',
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    data: params
  })
}

export function getBank(params) {
  return request({
    url: '/image/getBank',
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    data: params
  })
}

export function findCategoryByProductId(params) {
  return request({
    url: '/category/findCategoryByProductId',
    method: 'post',
    params
  })
}

export function findProductList(params) {
  return request({
    url: '/product/findProductList',
    method: 'post',
    params
  })
}

export function findFinanceList(params) {
  return request({
    url: '/finance/findFinanceList',
    method: 'post',
    params
  })
}

export function getCategoryByProductId(params) {
  return request({
    url: '/product/getCategoryByProductId',
    method: 'get',
    params: params
  })
}

export function findDictionaryByCode(params) {
  return request({
    url: '/dictionary/findDictionaryByCode',
    method: 'post',
    params
  })
}

export function getAggrementById(params) {
  return request({
    url: '/agreement/getById',
    method: 'get',
    params: params
  })
}

export function getAllProduct() {
  return request({
    url: '/product/getAllProduct',
    method: 'get'
  })
}

export function getInsureList(params) {
  return request({
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    url: '/weixinInsure/getInsureList',
    method: 'post',
    data: params
  })
}


// WEBPACK FOOTER //
// ./src/api/common.js